import { createGlobalState } from 'react-hooks-global-state';

export const { GlobalStateProvider, useGlobalState } = createGlobalState({
  // Constant do not remove
  defaultRodHours: [
    { name: 12, isChecked: true },
    { name: 24, isChecked: true },
    { name: 36, isChecked: true },
    { name: 48, isChecked: true },
    { name: 60, isChecked: true },
    { name: 72, isChecked: true },
  ],
  exclusiveRodHours: [
    { name: 12, isChecked: true },
    { name: 24, isChecked: true },
    { name: 36, isChecked: true },
    { name: 48, isChecked: true },
    { name: 60, isChecked: true },
    { name: 72, isChecked: true },
  ],
  // rodHours: [12, 24, 36, 48, 60, 72],
  rodHours: [
    { name: 12, isChecked: true, 1: '', 2: '', 3: '' },
    { name: 24, isChecked: true, 1: '', 2: '', 3: '' },
    { name: 36, isChecked: true, 1: '', 2: '', 3: '' },
    { name: 48, isChecked: true, 1: '', 2: '', 3: '' },
    { name: 60, isChecked: true, 1: '', 2: '', 3: '' },
    { name: 72, isChecked: true, 1: '', 2: '', 3: '' },
  ],
  rodNos: ['1', '2', '3'],
  cRodKeys: [
    'twelve',
    'twenty_four',
    'thirty_six',
    'forty_eight',
    'sixty',
    'seventy_two',
  ],
  rodKeys: ['one', 'two', 'three'],
  availableSwimTypes: ['Single', 'Double', 'Triple'],
  maxRod: 3,
  winterTiming: false,
  lakeSpecies: [
    'Carp',
    'Pike',
    'Chub',
    'Catfish',
    'Sturgeon',
    'Tench',
    'Perch',
    'Roach',
    'Rudd',
    'Barbel',
    'Bream',
    'Dace',
    'Grayling',
    'Mirror Carp',
    'Common Carp',
    'Crucian Carp',
    'Grass Carp',
    'Leather Carp',
    'Koi Carp',
    'F1',
    'Trout',
    'Goldfish',
    'Orph',
  ],
  maxAnglers: [
    1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21,
    22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40,
    41, 42, 43, 44, 45, 46, 47, 48, 49, 50,
  ],

  newSwimTypeForm: [],
  editLakeData: [],
  editingLake: false,

  // When user goes back and next we need this information to
  //  either create a new lake or update
  //  This will lake_id will be set once user click next on /lake_manager/swims page
  //  First time it will be empty

  // Post return call with lake id and swim id's
  lakeId: '',
  swimType: [],
  swimTypeDetail: '',
  swimTypeId: '',
  selectedSwimType: [{ value: 'Standard' }],
  selectedSwimSize: [{ value: '' }],
  doubleCheck: [{ value: false }],
  // Get call
  lakeInfoList: null,
  newSwimSize: '',

  amPmChecked: false,
  // START
  //  Populate data for post call
  lakeName: '',
  lakeServiceType: '',
  lakeServiceTypeName: '',
  lakeUserInput: null,

  // Placeholder for user
  nonAnglingGuest: 'no',

  customSlot: false,
  customSlotType: [],
  customSlotDetail: '',
  lakeExclusive: false,
  lakeExclusiveOnly: false,
  limitSimultaneous: 'no',
  lakeDescription: '',
  lakeRules: '',
  lakeInfo: '',
  customInfo: '',

  anglersAllowed: 1,
  chargingType: '',
  deposit: null,
  depositType: '',
  balanceDue: null,
  balanceDueType: '',
  balanceInAdvance: null,
  balanceInAdvanceType: '',
  onlineBalancePayments: false,
  balanceCancellation: false,
  balanceCancellationDue: null,
  balanceCancellationDueType: '',
  balanceNotification: false,
  balanceNotificationDue: null,
  balanceNotificationDueType: '',
  finalReminderActive: false,
  finalReminderDue: null,
  emailInfo: '',
  //
  concessionChecked: false,
  recurringValue: null,
  recurringPricing: '',
  userPricingInfo: null,
  userConcessionPricing: null,
  userInputSwims: [{ id: '', name: '', type: null, price: '', double: '' }],
  // userInputSwims: [
  //     {"id": "abcd1", "name": "", "type": null, "price": "", "notes": "", "image": null },
  //     {"id": "abcd2", "name": "", "type": null, "price": "", "notes": "", "image": null },
  //     {"id": "abcd5", "name": "", "type": null, "price": "", "notes": "", "image": null },
  //     {"id": "abcd6", "name": "", "type": null, "price": "", "notes": "", "image": null }
  // ],
  // END
  newRecurringPricing: '',
  lakeMainImage: '',
  lakeImages: ['', '', '', ''],
  summary: null,
  booking_days: null,
  description: null,
  angler_allowed: 0,
});
